{#if $getMarkerTemperatures}
  {#each $getMarkerTemperatures as location}
    <div
      class="weather-map-marker"
      class:selectedHolder="{location.selected == true}"
      style="{location.position}"
      on:click="{(e) => cityOptions.changeCity(location.city, false)}"
    >
      <div class="marker-icon">
        <img
          src="https://img.rtvslo.si/_static/novi/bootstrap/public/img/weather-widget/{utils.getDisplayIcon(
            location.icon,
            utils.convertTime(location.valid),
            utils.convertTime(location.sunrise),
            utils.convertTime(location.sunset),
          )}.svg"
          alt="{iconConverter.convert(location.icon_text)}"
        />
      </div>
      <div class="marker-temp">
        {location.t}
      </div>
      <div class="marker-wind-direction" style="{location.wind}"></div>
    </div>
  {/each}
{/if}

<script lang="ts">
  import { get } from "svelte/store";
  import { weatherStore } from "../store";
  import { cityOptions } from "../services/CityOptions";
  import { iconConverter } from "./../services/IconConverter";
  import { utils } from "../services/Utils";
  const { getMarkerTemperatures } = weatherStore;
</script>
